import React from "react";
import { Badge } from "../ui/badge";
import { ScrollArea } from "../ui/scroll-area";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";

export function TemplateSheet({ open, onOpenChange, templates, selectedTemplate, onApplyTemplate }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Contract Templates</SheetTitle>
        </SheetHeader>
        <ScrollArea className="h-[calc(100vh-200px)] mt-4">
          <div className="space-y-3">
            {templates.length > 0 ? (
              templates.map((template) => (
                <div
                  key={template.id}
                  className={`p-4 border rounded-sm cursor-pointer transition-colors hover:border-cyan-400 ${
                    selectedTemplate?.id === template.id ? "border-cyan-500 bg-cyan-50 dark:bg-cyan-900/20" : ""
                  }`}
                  onClick={() => onApplyTemplate(template)}
                  data-testid={`template-${template.id}`}
                >
                  <p className="font-medium">{template.name}</p>
                  <Badge variant="outline" className="text-xs mt-1">{template.category}</Badge>
                  <p className="text-xs text-slate-500 mt-1">{template.description}</p>
                </div>
              ))
            ) : (
              <p className="text-center text-slate-400 py-8">No templates available</p>
            )}
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
